import React, { useEffect } from 'react';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { Divide as Hamburger } from 'hamburger-react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Hidden from '@mui/material/Hidden';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import AccountMenu from '../../menu/AccountMenu';
import AppBarMobileMenu from '../../menu/AppBarMobileMenu';
import AppsMenu from '../../menu/AppsMenu';
import BreadCrumbs from '../../global/CustomBreadcrumbs';
import GlobalSearchBar from '../../search/GlobalSearchBar';
import NotificationsMenu from '../../menu/NotificationsMenu';
import SearchBarInput from 'src/pages/analytics/landing/components/landing-wrapper/search-component/search-bar-component.tsx';

import StyledSiteLogoAndName from '../../logo/StyledSiteLogoAndName';
import Notifications from '../../menu/notificatios';
import SegmentInfo from '../../menu/SegmentInfo';
import Survey from '../../analytics/survey/survey';

const AppBarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: theme.palette.primary.background,
  width: '100%',
  boxShadow: '0px 2px 12px 3px rgba(0, 0, 0, 0.14)',
  height: '40px',
  maxHeight: '40px',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${theme.spacing(0)} ${theme.spacing(2)}`
}));

const StyledAppbar = styled(MuiAppBar)(
  ({ theme, open, drawerwidth, sidebar }) => ({
    zIndex: theme.zIndex.drawer + 1,
    alignItems: 'center',
    backgroundColor: theme.palette.primary.background,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    ...(open &&
      sidebar == 'permanent' && {
        marginLeft: drawerwidth,
        width: `calc(100% - ${drawerwidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      })
  })
);

// const StyledToolbar = styled(Toolbar)(({ theme, open }) => ({
//   display: 'flex',
//   flexDirection: 'row',
//   alignItems: 'center',
//   width: '100%',
//   height: '40px',
//   maxHeight: '40px',
//   justifyContent: 'space-between',
//   padding: `${theme.spacing(0)} ${theme.spacing(2)}`,
//   backgroundColor: theme.palette.primary.background
// }));

const StyledDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '40px',
  maxHeight: '40px',
  padding: theme.spacing(0, 0),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  marginLeft: '-30px'
}));

function UserNavbar(props) {
  const {
    isDark,
    setTheme,
    userData,
    drawerWidth,
    sidebar,
    isSidebarOpen,
    setIsSidebarOpen,
    handleDrawerOpen,
    handleDrawerClose
  } = props;

  useEffect(() => {
    userData && setIsSidebarOpen(userData.preferences?.sidebar);
  }, []);

  useEffect(() => {
    userData && setIsSidebarOpen(userData.preferences?.sidebar);
  }, [userData]);

  return (
    <StyledAppbar
      open={isSidebarOpen}
      drawerwidth={drawerWidth}
      sidebar={sidebar}
    >
      <AppBarContainer open={isSidebarOpen}>
        {/* <Hidden mdDown>
          {!isSidebarOpen && (
            <StyledSiteLogoAndName
              needLogo
              needName={false}
              isDark={isDark}
              size='small'
            />
          )}
        </Hidden> */}
        <Hidden mdUp>
          <Hamburger
            color={isDark ? 'white' : '#000000'}
            toggle={() =>
              isSidebarOpen ? handleDrawerClose() : handleDrawerOpen()
            }
            toggled={isSidebarOpen}
            size={20}
            rounded
            easing='ease-in'
            sx={{
              padding: (theme) => theme.spacing(1)
            }}
          />
        </Hidden>
        <Hidden mdDown>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '12px'
            }}
          >
            <StyledDrawerHeader>
              <StyledSiteLogoAndName
                needLogo
                needName={false}
                width='30px'
                height='30px'
                isDark='Light'
                size='full'
              />
              <BreadCrumbs />
            </StyledDrawerHeader>
          </div>
        </Hidden>
        {/* <GlobalSearchBar scope='global' /> */}
        <SearchBarInput />
        <Box
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Hidden mdDown style={{ position: 'relative', right: '-32px' }}>
            <Survey />
            <SegmentInfo />
            {/* <AppsMenu isDark={isDark} /> */}
            <Notifications />
            <AccountMenu
              setTheme={setTheme}
              isDark={isDark}
              userData={userData}
            />
            <Box sx={{ m: 1 }} />
          </Hidden>
          <Hidden mdUp>
            <NotificationsMenu isDark={isDark} />
            <AppBarMobileMenu
              isDark={isDark}
              setTheme={setTheme}
              userData={userData}
            />
          </Hidden>
        </Box>
      </AppBarContainer>
    </StyledAppbar>
  );
}
export default UserNavbar;
